import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './components/App';
import './globals/i18n';
import './index.css';
import '@workbench/core/dist/css/globals.css';
import '@workbench/core/dist/workbench/workbench';

ReactDOM.render(<App />, document.getElementById('root'));
